// eslint-disable-next-line import/prefer-default-export
export const LIMITS_SCREEN = {
	HOME: 'home',
	DEPOSIT: 'deposit',
	TIME: 'time',
	WAGER: 'wager',
	SPEND: 'spend',
	LOSS: 'loss',
	BALANCE: 'balance'
};
